export default {
      id: "icon-pencil-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-pencil",
      toString: function () {
        return this.url;
      }
    }